import DealErrorMessageContent from '@/components/DealErrorMessageContent/DealErrorMessageContent';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import userUtils from '@/utils/user';

const DealErrorMessage = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const storedReason = sessionStorage.getItem('dealErrorMessageReason');
  const storedRole = sessionStorage.getItem('dealErrorMessageRole');
  const shouldShowDealExpired = storedReason === 'dealExpired';

  // Remove the flags once we use them, so this page doesn't show deal-expired copy on later visits.
  if (shouldShowDealExpired) {
    try {
      sessionStorage.removeItem('dealErrorMessageReason');
      sessionStorage.removeItem('dealErrorMessageRole');
    } catch {
      // ignore
    }
  }

  const title = shouldShowDealExpired
    ? t('registrationDealExpiredMessageTitle')
    : location.state?.title ?? t('pageNotFound');
  const description = shouldShowDealExpired
    ? t(userUtils.getDealExpiredDescriptionKey(storedRole))
    : location.state?.description ?? t('couldNotLocate');
  const buttonText = shouldShowDealExpired ? t('back') : location.state?.btnText ?? t('homepage');

  return (
    <div className='not-found h-full'>
      <DealErrorMessageContent title={title} description={description} buttonText={buttonText} />
    </div>
  );
};

export default DealErrorMessage;
